var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListModule',{attrs:{"label":_vm.$t('components.smart.featuredPositions.label'),"data":_vm.data(),"to":"jobdetail","is-loading":_vm.loading()}})}
var staticRenderFns = []

export { render, staticRenderFns }